import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class LoaderComponent {

  isLoading:boolean = false;
  constructor(public loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.isLoading$.subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

}
